import { fetchProviderByIds } from "../misc";
import { CategoryChartVisibilityFn } from "../categoryChart";

export const doTariffStructureKpisForTheProvidersExist: CategoryChartVisibilityFn = async ({ locationAdminIds }) => {
    const providers = await fetchProviderByIds(locationAdminIds);
    const doValidTariffProvidersExist =
        providers?.filter(d => d.residentialTariffStruct != null && d.residentialTariffStruct !== "blank")?.length > 0;

    return doValidTariffProvidersExist;
};
